export function retentionLabel(expiresAt: string | null, nowMs: number): string {
  if (!expiresAt) return 'Expiry unavailable';
  const remaining = new Date(expiresAt).getTime() - nowMs;
  if (remaining <= 0) return 'Retention expired';
  const minutes = Math.ceil(remaining / 60_000);
  if (minutes < 60) return `${minutes}m remaining`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return `${hours}h${remainder > 0 ? ` ${remainder}m` : ''} remaining`;
}

export function flattenCredentialData(
  data: Record<string, unknown>,
  prefix = ''
): Array<{ label: string; value: string }> {
  const rows: Array<{ label: string; value: string }> = [];
  for (const [key, value] of Object.entries(data)) {
    const label = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      rows.push({ label, value: String(value) });
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      rows.push(...flattenCredentialData(value as Record<string, unknown>, label));
    }
  }
  const priority = ['username', 'email', 'user', 'password', 'mfaSecret', 'apiKey'];
  return rows.sort((a, b) => {
    const ai = priority.indexOf(a.label);
    const bi = priority.indexOf(b.label);
    return (ai < 0 ? priority.length : ai) - (bi < 0 ? priority.length : bi);
  });
}
